/**
	* Draw event enum
	*
	* @remarks
	* Used mainly in views/DrawingTool
	*
	* @param New - New feature
	* @param Edit - Edited feature
	* @param Delete - Deleted feature
*/
enum DrawEvent {
	New,
	Edit,
	Delete
}

export default DrawEvent;